import { Link } from 'react-router-dom'

import { Checkmark12Filled } from '@fluentui/react-icons'
import { css, styled } from '@styles/theme'

export const CoursesStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'&.AccordionTrigger': {
			color: 'red',
		},

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	title: css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: '16px',
		marginTop: '19px',

		'@md': {
			flexDirection: 'row',
		},
	}),
	content: css({
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '32px',
		marginBottom: '29px',
	}),

	containerShow: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '14px',
		padding: '24px',
		marginTop: '20px',

		background: '$neutral10',
		borderRadius: '12px',
		border: '1px solid $neutral50',
	}),

	containerDescription: css({
		p: {
			_font: 'normal',
			fontSize: '$lg',
			fontWeight: 400,
			lineHeight: '26px',
			color: '$neutral160',
			paddingTop: '10px',
			marginBottom: '1rem',

			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 700,
				lineHeight: '19px',
				color: '$neutral160',
			},

			span: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 400,
				lineHeight: '26px',
				color: '$neutral160',
			},
		},

		hr: {
			margin: '10px 0px',
		},

		a: {
			cursor: 'pointer',
			color: '$blue20',
		},

		img: {
			width: '100%',
		},

		ul: {
			paddingLeft: '24px',
			paddingTop: '10px',
			marginBottom: '1rem',
			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 600,
				lineHeight: '24px',
				color: '$neutral160',
			},
		},
	}),

	containerGeneralLink: css({
		marginTop: '25px',
		padding: '31px',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '20px',
	}),

	containerLink: css({
		display: 'flex',
		flexWrap: 'wrap',
		gap: '53px 38px',
		height: '100%',
		maxHeight: '415px',
		overflowY: 'scroll',
		marginTop: '32px',

		background: '$neutral10',

		'&::-webkit-scrollbar': {
			width: '20px',
		},

		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '$primary',
			borderRadius: '20px',
			width: '11px',
		},

		'&::-webkit-scrollbar-track': {
			backgroundColor: '$neutral10',
			border: '1px solid $neutral40',
			borderRadius: '20px',
		},
	}),

	containerInfo: css({
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: '25.5px',

		'@md': {
			gridTemplateColumns: 'minmax(274px,auto) 1fr',
		},
	}),

	ImageShow: styled('img', {
		width: '100%',
		marginBottom: '20px',
		borderRadius: '12px',

		'@md': {
			width: '274px',
			height: '201px',
		},
	}),

	courseDescription: css({
		p: {
			_font: 'normal',
			fontSize: '$lg',
			fontWeight: 400,
			lineHeight: '25px',
			color: '$neutral100',
			paddingTop: '10px',
			marginBottom: '1rem',

			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 700,
				lineHeight: '19px',
				color: '$neutral160',
			},

			span: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 400,
				lineHeight: '26px',
				color: '$neutral160',
			},
		},

		hr: {
			margin: '10px 0px',
		},

		a: {
			cursor: 'pointer',
			color: '$blue20',
		},

		img: {
			width: '100%',
		},

		ul: {
			paddingLeft: '24px',
			paddingTop: '10px',
			marginBottom: '1rem',
			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 600,
				lineHeight: '24px',
				color: '$neutral160',
			},
		},
	}),

	LinkModule: styled(Link, {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: '100%',
		height: '135px',
		padding: '16px',
		cursor: 'pointer',
		position: 'relative',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',

		h3: {
			textAlign: 'center',
		},

		'@sm': {
			maxWidth: '217px',
		},

		variants: {
			isFinished: {
				true: {
					background: '$courseCardBackground',
				},
			},
		},
	}),

	moduleTitle: css({
		display: 'flex',
		justifyContent: 'space-between',
		gap: '9px',

		p: {
			height: '77px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			display: '-webkit-box',
			'-webkit-line-clamp': '4',
			'-webkit-box-orient': 'vertical',
		},
	}),

	moduleInfos: css({
		display: 'flex',
		gap: '19px',
	}),

	moduleInfo: css({
		display: 'flex',
		gap: '7px',

		svg: {
			color: '$neutral80',
			width: '18px',
			height: '18px',
		},
	}),

	IconCheckMark: styled(Checkmark12Filled, {
		width: '26px',
		height: '26px',
		borderRadius: '100%',
		background: '$green',
		color: '$neutral10',
	}),
}
